import { useCacheStore } from '@/stores/cache-store'
import { keyBuilderService } from '../../services/key-builder'

/**
 * Belirli bir öneke sahip tüm cache girdilerini siler
 * @param {string} prefix - Silinecek öneke sahip cache anahtarları
 */
export const invalidateByPrefix = (prefix) => {
  const cacheStore = useCacheStore()
  const pattern = keyBuilderService.createPattern(prefix)
  cacheStore.deleteByPattern(pattern)
  
  // İstatistik için
  if (typeof window !== 'undefined' && window.__CACHE_STATS__) {
    window.__CACHE_STATS__.invalidations = (window.__CACHE_STATS__.invalidations || 0) + 1
  }
  
  if (process.env.VUE_APP_MODE === 'development') {
    console.log(`🗑️ Cache INVALIDATE by prefix: ${prefix}`)
  }
}